import React from 'react';
import {commons} from "../../hook/common";
import history from "../../route/history";
import {alertActions, authActions, regisActions} from "../../store/actions";
import {connect} from "react-redux";

/**
 * React Native App CallBack
 */
const RNListener = props => {
    const listener = event => {
        const resultObj = JSON.parse(event.data);
        const key = Object.keys(resultObj)[0];
        const value = resultObj[key];

        if (key === "fcmToken") {
            if (value && value !== 'null') {
                let memberId = JSON.parse(localStorage.getItem('user'))?.payload?.memberId;
                props.uploadPushInfo({deviceId: value, memberId});
            }
        }

    };

    if (commons.isMobile()) {
        /** android */
        document.addEventListener("message", listener);
        /** ios */
        window.addEventListener("message", listener);
    }

    return <></>
};

const mapStateToProps = state => {
    return {
    }
}
const actionCreators = {
    uploadPushInfo: authActions.uploadPushInfo
}

export default connect(
    mapStateToProps,
    actionCreators
)(RNListener)
